import { render, staticRenderFns } from "./b2bordersubmission.vue?vue&type=template&id=01c00d12&scoped=true"
import script from "./b2bordersubmission.vue?vue&type=script&lang=js"
export * from "./b2bordersubmission.vue?vue&type=script&lang=js"
import style0 from "./b2bordersubmission.vue?vue&type=style&index=0&id=01c00d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c00d12",
  null
  
)

export default component.exports